import dayjs from 'dayjs'

/**
 * Converts Notification Center filter values into `GET api/ActionLog` query params.
 * The "to" date is inclusive (end of day).
 * @param {{ dateFrom: any, dateTo: any, userId: string|number, category: string, organization: string|number }} filters
 * @returns {Array<[string, string]>}
 */
export function buildNotificationFilterParams(filters) {
  const params = []
  const dateFrom = filters?.dateFrom ? dayjs(filters.dateFrom) : null
  const dateTo = filters?.dateTo ? dayjs(filters.dateTo) : null
  if (dateFrom?.isValid()) params.push(['after', dateFrom.startOf('day').toJSON()])
  if (dateTo?.isValid()) params.push(['before', dateTo.endOf('day').toJSON()])
  if (filters?.userId !== '' && filters?.userId != null) params.push(['user_id', String(filters.userId)])
  if (filters?.category) params.push(['category', filters.category])
  if (filters?.organization !== '' && filters?.organization != null) params.push(['organization', String(filters.organization)])
  return params
}
